import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import Cta from "src/Component/card-components/Cta";

const DynamicWhyChooseThisUniversitiesPage = ({ rankingsData }) => {
  return (
    <Box sx={{ textAlign: "center", backgroundColor: "#e6f9fc", py: 6 }}>
      <Typography variant="h4" fontWeight="bold" color="teal" gutterBottom>
        ~Why Choose This University?~
      </Typography>
      <Grid container spacing={4} justifyContent="center" sx={{ mb: 2 }}>
        {rankingsData.map((item) => (
          <Grid item key={item.id} xs={12} sm={6} md={3}>
            <Paper
              elevation={3}
              sx={{
                width: 150,
                height: 150,
                borderRadius: "50%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                border: "2px solid teal",
                backgroundColor: "white",
              }}
            >
              <Typography variant="h6" color="teal">
                {item.rank}
              </Typography>
            </Paper>
            <Typography mt={2} variant="body1">
              {item.title}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Cta />
    </Box>
  );
};

export default DynamicWhyChooseThisUniversitiesPage;
